import React, { useState } from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"

import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import leftArrow from "../../../assets/images/icons/left-arrow.svg"
import file from "../../../assets/images/icons/file-type.svg"
import check from "../../../assets/images/icons/right-check.svg"

const ICDRequestDetails = () => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "ICD Request Details"

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/icd-investments/my-icd-requests")
      }
    } catch (error) {}
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex align-items-center gap-2 mb-4">
            <Link to={"/icd-investments/my-icd-requests"}>
              <img src={leftArrow} alt="" />
            </Link>
            <div className="page-title-name">ICD Request Details </div>
          </div>
          {/* <Breadcrumbs
              title={"Wealth Partner Details"}
              breadcrumbItem={"Wealth Partner Details"}
            /> */}
          <Row>
            <Col xl={12}>
              <div className="d-flex align-items-center mb-4 justify-content-between">
                <CardTitle className="">
                  REIT Code: <span> IRT-REIT-2025 </span>
                </CardTitle>
              </div>
              <Card>
                <CardBody>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Request Code</Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Request Code"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Status
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Status"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Requested On
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Requested On"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Approved On</Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Investment Details</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Investment Amount
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Tenure
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Interest Rate</Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Expected Maturity Amount
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Fund Availability Date
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Payout Mode
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={12}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Comments / Notes
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="textarea"
                          className="form-control textarea"
                          id="horizontal-email-id "
                          placeholder="Comments / Notes"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <CardTitle className="pb-4">Uploaded Documents</CardTitle>
              <div className="documents-section">
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>PAN Card.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Cancelled Cheque.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Aadhar Card.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
              </div>
              <div className="buttons">
                <Button className="counteroffer">Withdraw Request</Button>
                <Button className="btn btn-primary">Edit Request</Button>
                {/* <Button className="reject">Reject</Button>
                <Button className="btn btn-contact-rm">Contact RM</Button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ICDRequestDetails
